import { toast } from "@/hooks/use-toast";
import { QueueCustomer } from "@/types/fb-type";
import { useState } from "react";
import { ParticipantQueueBubble } from "./ParticipantQueueBubble";

interface ParticipantListProps {
  participants: QueueCustomer[];
  onDropProduct?: (
    customer: QueueCustomer,
    productId: string,
    variantId: string
  ) => void;
  activeId?: string;
  onSelect: (p: QueueCustomer) => void;
  onReplyComment?: (commentId: string) => void;
}

export function ParticipantList({
  participants,
  activeId,
  onDropProduct,
  onSelect,
}: ParticipantListProps) {
  const [dragOverId, setDragOverId] = useState<string | null>(null);

  return (
    <div className="w-full h-full overflow-y-auto border rounded-md bg-white">
      {participants.length === 0 && (
        <div className="p-4 text-center text-sm text-gray-500">
          No customers in queue
        </div>
      )}

      <ul className="divide-y">
        {participants.map((q) => {
          const handleDragOver: React.DragEventHandler<HTMLLIElement> = (e) => {
            if (!onDropProduct) return;
            e.preventDefault();
            setDragOverId(q.id);
          };

          const handleDragLeave: React.DragEventHandler<HTMLLIElement> = () => {
            if (!onDropProduct) return;
            setDragOverId((prev) => (prev === q.id ? null : prev));
          };

          const handleDrop: React.DragEventHandler<HTMLLIElement> = (e) => {
            if (!onDropProduct) return;
            e.preventDefault();
            const productId = e.dataTransfer.getData("application/product-id");
            const variantId = e.dataTransfer.getData("application/variant-id");

            setDragOverId(null);

            if (productId) {
              onDropProduct(q, productId, variantId);
            }
          };

          return (
            <ParticipantQueueBubble
              key={q.id}
              q={q}
              active={activeId === q.id}
              dragOver={dragOverId === q.id}
              enableDropHighlight={!!onDropProduct}
              onSelect={onSelect}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
              onCopied={() => toast({ title: "Copied", description: "Facebook link copied." })}
            />
          );
        })}
      </ul>
    </div>
  );
}
